import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppConfigService } from "app/core/config/app-config.service";
import { IConfiguracoes } from "app/core/config/configuracoes.types";
import { environment as env } from "environments/environment";
import { Subscription } from "rxjs";

@Component({
    selector: "cadastro-footer",
    templateUrl: "app-footer.component.html",
    standalone: false
})
export class AppFooter implements OnInit, OnDestroy {
  currentYear;
  config: IConfiguracoes;
  version = env.version;
  configSubscription: Subscription;

  constructor(private _config: AppConfigService) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.configSubscription = this._config.config$
      .subscribe((config) => (this.config = config));
  }

  ngOnDestroy(): void {
    this.configSubscription.unsubscribe();
  }
}
